import { post, get } from '../index'

export interface ICertificateClassroomQuery {
  certificationId?: number | string
  teachingType: number | string // 0 - 线下，1 - 线上
  regionId?: number | string | null
  languageComplete?: string
  kind?: number | string // 0-CGS 1-HSC
  keyword: string | number
}

export async function getClassroomList (data: ICertificateClassroomQuery) {
  return await post('/certification/classroom/getOfCertificateType', data)
}

export async function getPracticalExamList (data?: Partial<ICertificateClassroomQuery>) {
  return await post('/certification/practicalExam/listPracticalExamCard', data)
}

export async function getDietHisInfo () {
  return await post('/user/registration/getLatestClassroomByUserId')
}

export async function getClassroomInfo (data: { id: string | number }) {
  return await get('/certification/classroom/getById', data)
}

// 获取面授列表的认证
export async function getCertificationOfClassroom (data: { kind: string }) {
  return await get('/certification/getCertificationOfClassroom', data)
}

export async function getRegionOfClassroom (data: {
  teachingType: string
  kind: string
}) {
  return await post('/certification/classroom/getRegionOfCertificationType', { ...data })
}
